import { msalInstance } from '../msalInstance';
import { getMsalApiToken } from './msalApiToken';
import { protectedResources } from '../authConfig';

const API_BASE = protectedResources.api.endpoint.replace(/\/$/, '');

/** Corpos em stream só podem ser lidos uma vez, então não podem ser reenviados. */
function podeReenviar(body: BodyInit | null | undefined): boolean {
  return !(body instanceof ReadableStream);
}

async function requestWithToken(
  url: string,
  init: RequestInit,
  forceRefresh: boolean,
): Promise<Response> {
  const headers = new Headers(init.headers);
  headers.set('Authorization', `Bearer ${await getMsalApiToken(msalInstance, false, forceRefresh)}`);
  return fetch(url, { ...init, headers });
}

/** Fetch autenticado — envia Bearer token (Azure AD) exigido pelo backend. */
export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const url = path.startsWith('http') ? path : `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`;

  const response = await requestWithToken(url, init, false);
  if (response.status !== 401 || !podeReenviar(init.body)) return response;

  return requestWithToken(url, init, true);
}

export { API_BASE };
